export default __webpack_public_path__ + "static/media/SALegend.f7d9a2da.png";